export default __webpack_public_path__ + "static/media/065.73099b52.jpg";